import { fork } from 'redux-saga/effects';

import sagaWatchersAppointment from './sagaWatchersAppointment';

/**
 * Watchers to keep redux, relay, and react-query stores updated when the app receives
 * a socket event or a success mutation after a REST API call
 *
 * - Update redux store by normalizing the data and storing it inisde `normalizr.entities`
 * - Update relay store by updating the record dynamically
 * - TODO define pattern to update records/lookups inside react-query store
 */
export default function* sagaWatchers() {
  yield fork(sagaWatchersAppointment);
}
